import Vue from 'vue'
import Vuex from 'vuex'
import roomSelected from './modules/RoomSelected'
import roomType from './modules/RoomType'
import reservation from './modules/Reservation'
import locale from './modules/Locale-i18n'

Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'

export default new Vuex.Store({

  modules: {
    roomSelected,
    roomType,
    reservation,
    locale
  },
  plugins: [createPersistedState()]

})
